import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import Anim from "./Anim";
import { RelatedArticles } from "../BlogEnhancements";

export default function PostBottom({ slug, tags, allPosts, featuredImage, title }) {
  return (
    <>
      {/* Featured image */}
      {featuredImage && (
        <section className="-mt-1">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <Anim>
              <div className="rounded-xl overflow-hidden shadow-lg -mt-4">
                <img src={featuredImage} alt={title} className="w-full aspect-[2/1] object-cover" data-testid="post-featured-image" />
              </div>
            </Anim>
          </div>
        </section>
      )}
    </>
  );
}

export function PostCtaBar() {
  return (
    <section className="py-12 bg-surface_alt border-t border-border_custom" data-testid="post-cta">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          <Link to="/blog" className="inline-flex items-center gap-2 text-text_muted hover:text-emerald_deep text-sm transition-colors" data-testid="back-to-blog">
            <ArrowLeft size={14} /> Back to All Articles
          </Link>
          <a href="/consultation" className="inline-flex items-center gap-2 bg-accent text-emerald_deep px-8 py-3 text-sm tracking-wide font-semibold hover:bg-accent_light transition-all rounded-full" data-testid="post-cta-consult">
            Book Consultation <ArrowRight size={14} />
          </a>
        </div>
      </div>
    </section>
  );
}

export function PostRelated({ slug, tags, allPosts }) {
  return <RelatedArticles currentSlug={slug} currentTags={tags} allPosts={allPosts} />;
}

export function PostDisclaimer() {
  return (
    <aside className="py-8 bg-bone border-t border-border_custom" data-testid="post-disclaimer">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <p className="text-xs text-text_muted/70 leading-relaxed text-center">
          <strong className="text-text_muted">Disclaimer:</strong> This article is for educational purposes only and does not constitute medical advice or diagnosis. Consult a qualified healthcare professional for personalised guidance. Nutrition supports reproductive health but does not replace medical treatment.
        </p>
      </div>
    </aside>
  );
}
